/* JDM Legends — T3+ motion system.
   Lenis smooth scroll + GSAP ScrollTrigger (scrubbed only — NO pinning, ever).
   Degrades cleanly: no GSAP → IntersectionObserver reveals; reduced-motion → everything instant.
   Reveal hooks: [data-rv] rise, [data-rv-img] clip reveal, state class `jdm-on`.
   Other hooks: [data-parallax="0.14"] translateY scrub, [data-mag] magnetic button wrap,
   #jdm-prog progress hairline, [data-jdm-type] typewriter. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('jdm-motion');

  function revealAllInstant() {
    document.querySelectorAll('[data-rv],[data-rv-img]').forEach(function (el) {
      el.classList.add('jdm-on');
    });
  }

  // ---- progress hairline (rAF-free: scroll events, timestamp throttled) ----
  var progI = document.querySelector('#jdm-prog i');
  var lastRun = 0;
  function onScroll() {
    var now = Date.now();
    if (now - lastRun < 16) return;
    lastRun = now;
    if (progI) {
      var total = document.documentElement.scrollHeight - window.innerHeight;
      if (total > 0) progI.style.transform = 'scaleX(' + Math.min(1, window.scrollY / total) + ')';
    }
    // reveal fallback for throttled tabs / stalled IO
    var vh = window.innerHeight;
    document.querySelectorAll('[data-rv]:not(.jdm-on),[data-rv-img]:not(.jdm-on)').forEach(function (el) {
      var b = el.getBoundingClientRect();
      if (b.top < vh * 0.88 && b.bottom > 0) el.classList.add('jdm-on');
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (reduced) { revealAllInstant(); onScroll(); return; }

  // ---- Lenis smooth scroll ----
  var lenis = null;
  if (window.Lenis) {
    try {
      lenis = new window.Lenis({ lerp: 0.12, smoothWheel: true });
      function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
    } catch (e) { lenis = null; }
  }

  // ---- GSAP reveals + scrubbed parallax ----
  var hasGsap = window.gsap && window.ScrollTrigger;
  if (hasGsap) {
    gsap.registerPlugin(ScrollTrigger);
    if (lenis) { lenis.on('scroll', ScrollTrigger.update); }

    document.querySelectorAll('[data-rv],[data-rv-img]').forEach(function (el) {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 88%',
        once: true,
        onEnter: function () { el.classList.add('jdm-on'); }
      });
    });

    document.querySelectorAll('[data-parallax]').forEach(function (el) {
      var amt = parseFloat(el.getAttribute('data-parallax')) || 0.12;
      gsap.to(el, {
        yPercent: amt * -100,
        ease: 'none',
        scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
  } else {
    // vanilla fallback: IO + the scroll-loop fallback above
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('jdm-on'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14 });
    document.querySelectorAll('[data-rv],[data-rv-img]').forEach(function (el) { io.observe(el); });
  }
  onScroll();

  // ---- magnetic buttons ----
  if (window.matchMedia('(hover:hover)').matches) {
    document.querySelectorAll('[data-mag]').forEach(function (wrap) {
      var btn = wrap.querySelector('.jdm-btn') || wrap.firstElementChild;
      if (!btn) return;
      wrap.addEventListener('mousemove', function (e) {
        var b = wrap.getBoundingClientRect();
        btn.style.transform = 'translate(' + (e.clientX - b.left - b.width / 2) * 0.18 + 'px,'
          + (e.clientY - b.top - b.height / 2) * 0.3 + 'px)';
      });
      wrap.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  // ---- typewriter readouts ----
  document.querySelectorAll('[data-jdm-type]').forEach(function (el) {
    var txt = el.getAttribute('data-jdm-type') || '';
    var delay = parseInt(el.getAttribute('data-jdm-type-delay') || '1600', 10);
    el.textContent = '';
    var i = 0;
    setTimeout(function tick() {
      el.textContent = txt.slice(0, ++i);
      if (i < txt.length) setTimeout(tick, 26);
    }, delay);
  });

  // ---- toast helper (used by section scripts) ----
  window.jdmToast = function (msg) {
    var t = document.getElementById('jdm-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'jdm-toast'; document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('jdm-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('jdm-on'); }, 3400);
  };
})();
